// Mobile menu overlay
(function() {
  const MENU_DATA = [
    {
      title: 'Products',
      url: null,
      groups: [
        {
          heading: "Men's",
          links: [
            { title: 'Shirts', url: '/collections/shirts' },
            { title: 'Overshirts', url: '/collections/blazers-overshirts' },
            { title: 'Swimwear', url: '/collections/swimwear' },
            { title: 'Shorts', url: '/collections/shorts' }
          ]
        },
        {
          heading: 'Accessories',
          links: [
            { title: 'Wallets & Card Holders', url: '/collections/wallets-cardholders' },
            { title: 'Socks', url: '/collections/socks' },
            { title: 'Belts', url: '/collections/belts' },
            { title: 'Ties', url: '/collections/ties' },
            { title: 'Pocket Squares', url: '/collections/pocket-squares' }
          ]
        },
        {
          heading: 'Tailoring',
          links: [
            { title: 'How it works', url: '/pages/soft-tailoring-how-it-works' },
            { title: 'Fit Guarantee', url: '/pages/fit-guarantee' },
            { title: 'Book Consultation', url: '/pages/book-appointment' }
          ]
        }
      ],
      image: {
        src: 'https://cdn.shopify.com/s/files/1/0226/6556/0144/files/the-cotton-shirt-flat-lay-navy.webp?v=1782729480',
        alt: 'The Cotton Overshirt',
        caption: 'The Cotton Overshirt',
        url: 'https://onceaday.se/products/the-cotton-over-shirt-navy?variant=41210631487568'
      }
    },
    {
      title: 'Resources',
      url: null,
      groups: [
        {
          heading: 'Support',
          links: [
            { title: 'Shipping & Returns', url: '/pages/shipping-returns' },
            { title: 'Contact', url: '/pages/contact' },
            { title: 'Stores', url: '/pages/store-6-elgin-street-hong-kong' },
            { title: 'Book Consultation', url: '/pages/book-appointment' }
          ]
        },
        {
          heading: 'Philosophy',
          links: [
            { title: 'Demand Driven Goods', url: '/pages/demand-driven-goods' },
            { title: 'Custom Size', url: '/pages/custom-size' },
            { title: 'Micro Stock', url: '/pages/micro-stock' },
            { title: 'Made To Order', url: '/pages/made-to-order' },
            { title: 'Soft Tailoring', url: '/pages/soft-tailoring-how-it-works' },
            { title: 'Fit Guarantee', url: '/pages/fit-guarantee' }
          ]
        },
        {
          heading: 'About',
          links: [
            { title: 'About Us', url: '/pages/about' }
          ]
        }
      ],
      image: null
    },
    {
      title: 'Editorial',
      url: '/blogs/editorial',
      groups: [],
      image: null
    }
  ];

  const FOOTER_LINKS = [
    { title: 'Contact', url: '/pages/contact' },
    { title: 'Shipping & Returns', url: '/pages/shipping-returns' },
    { title: 'Fit Guarantee', url: '/pages/fit-guarantee' },
    { title: 'Register a Return', url: '/pages/make-a-return' }
  ];

  function getCurrencyHTML() {
    const currentCurrency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : 'SEK';
    const flags = { SEK: '🇸🇪', HKD: '🇭🇰', USD: '🇺🇸', EUR: '🇪🇺', GBP: '🇬🇧' };
    const flag = flags[currentCurrency] || '';
    return `
      <div class="oad-mobile-menu-currency-wrapper">
        <span class="oad-mobile-menu-currency-display">${flag} ${currentCurrency} ∨</span>
        <select class="oad-mobile-menu-currency-select-hidden" aria-label="Currency">
          <option value="SEK"${currentCurrency==='SEK'?' selected':''}>SEK — Swedish Krona</option>
          <option value="HKD"${currentCurrency==='HKD'?' selected':''}>HKD — Hong Kong Dollar</option>
          <option value="USD"${currentCurrency==='USD'?' selected':''}>USD — US Dollar</option>
          <option value="EUR"${currentCurrency==='EUR'?' selected':''}>EUR — Euro</option>
          <option value="GBP"${currentCurrency==='GBP'?' selected':''}>GBP — British Pound</option>
        </select>
      </div>`;
  }

  function buildOverlay() {
    if (document.querySelector('.oad-mobile-menu-overlay')) {
      return document.querySelector('.oad-mobile-menu-overlay');
    }

    const overlay = document.createElement('div');
    overlay.className = 'oad-mobile-menu-overlay';

    let tabsHTML = '';
    let panelsHTML = '';

    MENU_DATA.forEach((item, i) => {
      tabsHTML += `<button class="oad-mobile-menu-tab${i === 0 ? ' active' : ''}" data-index="${i}"${item.url ? ` data-direct="${item.url}"` : ''}>${item.title}</button>`;

      panelsHTML += `<div class="oad-mobile-menu-panel${i === 0 ? ' active' : ''}" data-panel="${i}">`;
      item.groups.forEach(group => {
        panelsHTML += `<div class="oad-mobile-menu-group">`;
        panelsHTML += `<span class="oad-mobile-menu-heading">${group.heading}</span>`;
        group.links.forEach(link => {
          panelsHTML += `<a href="${link.url}" class="oad-mobile-menu-link">${link.title}</a>`;
        });
        panelsHTML += `</div>`;
      });
      if (item.image) {
        panelsHTML += `
          <div class="oad-mobile-menu-image-block">
            <a href="${item.image.url}" class="oad-mobile-menu-panel-image-link">
              <img src="${item.image.src}" alt="${item.image.alt}" class="oad-mobile-menu-panel-image">
            </a>
            <a href="${item.image.url}" class="oad-mobile-menu-image-caption">${item.image.caption}</a>
          </div>`;
      }
      panelsHTML += '</div>';
    });

    const footerLinksHTML = FOOTER_LINKS.map(l =>
      `<a href="${l.url}" class="oad-mobile-menu-footer-link">${l.title}</a>`
    ).join('');

    overlay.innerHTML = `
      <div class="oad-mobile-menu-header">
        <a href="/" class="oad-mobile-menu-logo-link">
          <img src="https://cdn.shopify.com/s/files/1/0226/6556/0144/files/once_a_day_log.png?v=1758133828"
               alt="Once a Day"
               class="oad-mobile-menu-logo"
               onerror="this.style.display='none'">
        </a>
        <button class="oad-mobile-menu-close" aria-label="Close menu">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      <div class="oad-mobile-menu-tabs">${tabsHTML}</div>
      <div class="oad-mobile-menu-content">${panelsHTML}</div>
      <div class="oad-mobile-menu-footer">
        ${footerLinksHTML}
        <div class="oad-mobile-menu-currency">
          ${getCurrencyHTML()}
        </div>
      </div>
    `;

    document.body.appendChild(overlay);

    overlay.querySelector('.oad-mobile-menu-close').addEventListener('click', () => closeOverlay(overlay));

    overlay.querySelectorAll('.oad-mobile-menu-tab').forEach(tab => {
      tab.addEventListener('click', () => {
        if (tab.dataset.direct) {
          window.location.href = tab.dataset.direct;
          return;
        }
        const index = tab.dataset.index;
        overlay.querySelectorAll('.oad-mobile-menu-tab').forEach(t => t.classList.toggle('active', t.dataset.index === index));
        overlay.querySelectorAll('.oad-mobile-menu-panel').forEach(p => p.classList.toggle('active', p.dataset.panel === index));
      });
    });

    const currencySelect = overlay.querySelector('.oad-mobile-menu-currency-select-hidden');
    if (currencySelect) {
      currencySelect.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('currency', currencySelect.value);
        window.location.href = url.toString();
      });
    }

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 750) closeOverlay(overlay);
    });

    return overlay;
  }

  function openOverlay(overlay) {
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeOverlay(overlay) {
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  function init() {
    const overlay = buildOverlay();
    const menuBtn = document.querySelector('.header__icon--menu');
    if (menuBtn && overlay) {
      menuBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        openOverlay(overlay);
      }, true);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(init, 300));
  } else {
    setTimeout(init, 300);
  }
})();
